/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Assign_Track_NoneInputs */



/**
* | output |
* | --- |
* | "Assign Track None" |
*
* @param {Shortcut_Keys_Name_Assign_Track_NoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_assign_track_none = /** @type {((inputs?: Shortcut_Keys_Name_Assign_Track_NoneInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Assign_Track_NoneInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune piste à attribuer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Spur zuweisen: Keine")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assegna traccia nessuna")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Назначить трек Нет")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asignar pista ninguna")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分配轨道：无")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トラック割り当てなし")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रैक असाइन न करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atribuir faixa Nenhuma")
	return /** @type {LocalizedString} */ ("Assign Track None")
});